import * as types from "./stateLicenseActionType";

export const fetchStateLicenseRequest = (payload = {}) => ({
  type: types.FETCH_STATE_LICENSE_REQUEST,
  payload,
});

export const fetchStateLicenseSuccess = (data) => ({
  type: types.FETCH_STATE_LICENSE_SUCCESS,
  payload: data,
});

export const fetchStateLicenseFailure = (error) => ({
  type: types.FETCH_STATE_LICENSE_FAILURE,
  payload: error,
});

export const fetchStateLicenseNotesRequest = (payload) => ({
  type: types.FETCH_STATE_LICENSE_NOTES_REQUEST,
  payload,
});

export const fetchStateLicenseNotesSuccess = (data) => ({
  type: types.FETCH_STATE_LICENSE_NOTES_SUCCESS,
  payload: data,
});

export const fetchStateLicenseNotesFailure = (error) => ({
  type: types.FETCH_STATE_LICENSE_NOTES_FAILURE,
  payload: error,
});

export const addStateLicenseNoteRequest = (payload) => ({
  type: types.ADD_STATE_LICENSE_NOTE_REQUEST,
  payload,
});

export const addStateLicenseNoteSuccess = (noteText, detailsId) => ({
  type: types.ADD_STATE_LICENSE_NOTE_SUCCESS,
  payload: { noteText, detailsId },
});

export const addStateLicenseNoteFailure = (error) => ({
  type: types.ADD_STATE_LICENSE_NOTE_FAILURE,
  payload: error,
});

export const clearStateLicenseNotes = () => ({
  type: types.CLEAR_STATE_LICENSE_NOTES,
});
